$('#formUpdateUser #avatar').click(function(){
    $('#formUpdateUser .file-field input').click();
});
$('#numberListViewsUser').val(arvViewsUser);
$( document ).ready(function() {
    $('.add-new-contact-view-user').click(function () {
        $('.add-new-contact-view-user').css('visibility','hidden');
        numberListViewsUser = numberListViewsUser + 1;
        scriptArViewsUser[numberListViewsUser] = "new";
        arvViewsUser = scriptArViewsUser.toString();
        $('#numberListViewsUser').val(arvViewsUser);
        $('.moreContact').append('' +
            '<div class="container-createClient">\n' +
            '    <div class="container-select-2">\n' +
            '        <div class="row">\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    <span>Contacto</span> 0'+numberListViewsUser+'\n' +
            '                </h1>\n' +
            '            </div>\n' +
            '            <div class="col l8">\n' +
            '                <h1 class="align-center">\n' +
            '                    Contacto de emergencia\n' +
            '                </h1>\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h3 class="add-new-contact-view-user" onclick="$(\'#add-new-contact-view-user\').click();"">\n' +
            '                    <img src="'+https+'img/icons/add_purple_circle_2.svg" alt="">\n' +
            '                    Agregar Contacto\n' +
            '                </h3>' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '    <div class="form align-center">\n' +
            '        <div class="row">\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Nombre\n' +
            '                </h1>\n' +
            '                <input id="name_'+numberListViewsUser+'" name="name_'+numberListViewsUser+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    Telefono\n' +
            '                </h1>\n' +
            '                <input id="phone_'+numberListViewsUser+'" name="phone_'+numberListViewsUser+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    Correo\n' +
            '                </h1>\n' +
            '                <input id="mail_'+numberListViewsUser+'" name="mail_'+numberListViewsUser+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l2">\n' +
            '                <h1>\n' +
            '                    Celular\n' +
            '                </h1>\n' +
            '                <input id="cellphone_'+numberListViewsUser+'" name="cellphone_'+numberListViewsUser+'" type="text" class="input">\n' +
            '            </div>\n' +
            '            <div class="col l3">\n' +
            '                <h1>\n' +
            '                    Nota\n' +
            '                </h1>\n' +
            '                <input id="note_'+numberListViewsUser+'" name="note_'+numberListViewsUser+'" type="text" class="input">\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>');
    });
});
let fileUser = '';
$('.btnUpdateUser').click(function () {
    $('#formUpdateUser').submit();
 });

 $("#formUpdateUser #photo").on("change", function(e) {
    fileUser = this.files[0];
});

$("#formUpdateUser").on('submit', function (e) {
    e.preventDefault();
    elementsForm = [
        "name",
        "email",
        "user",
        "type",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);

    if(contLogin == 0)
    {
        swal({
            text: "Debes completar todos los datos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }

    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    var formData = new FormData();
    formData.append("idViewsUser", $("#idViewsUser").val());
    formData.append("name", $("#name").val());
    formData.append("cc", $("#cc").val());
    formData.append("email", $("#email").val());
    formData.append("email_per", $("#email_per").val());
    formData.append("eps", $("#eps").val());
    formData.append("pc_status", $("#pc_status").val());
    formData.append("shirt", $("#shirt").val());
    formData.append("phone", $("#phone").val());
    formData.append("user", $("#user").val());
    formData.append("password", $("#password").val());
    formData.append("type", $("#type").val());
    formData.append("photo", fileUser);
    formData.append("numberListViewsUser", $("#numberListViewsUser").val());
    for(i=0;i<scriptArViewsUser.length;i++){
        if(scriptArViewsUser[i] == 'si' || scriptArViewsUser[i] == 'new'){
            formData.append("name_"+i, $("#name_"+i).val());
            formData.append("phone_"+i, $("#phone_"+i).val());
            formData.append("mail_"+i, $("#mail_"+i).val());
            formData.append("cellphone_"+i, $("#cellphone_"+i).val());
            formData.append("note_"+i, $("#note_"+i).val());
        }
    }

    $.ajax({
        url: https + "updateUser",
        method: "POST",
        data: formData,
        contentType: false,
        cache: false,
        processData: false,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formUpdateUser")[0].reset();
                swal.close();
                swal({
                    text: "Usuario Creado con exito",
                    icon: imageURL,
                    button: "OK!",
                });
                setInterval(function () {
                    location.reload()
                }, 200)
            }else if($.trim(data) == "3") {
                $("#user").addClass('error');
                swal({
                    text: "Este usuario ya existe",
                    icon: imageURL,
                    button: "OK!",
                });
            }else if($.trim(data) == "4") {
                $("#email").addClass('error');
                swal({
                    text: "Este correo ya esta registrado",
                    icon: imageURL,
                    button: "OK!",
                });
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('#'+elementsForm[i]).removeClass('error');
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }

    }
    return contLogin;
}